export default __webpack_public_path__ + "static/media/s_2.6b680335.jpg";